// removed by extract-text-webpack-plugin
module.exports = {"textContainer":"src-components-ExternalInvest-DisclaimerViews-___index__textContainer___3MMkd","numbered":"src-components-ExternalInvest-DisclaimerViews-___index__numbered___Dy4e8","lettered":"src-components-ExternalInvest-DisclaimerViews-___index__lettered___3wqtL","roman":"src-components-ExternalInvest-DisclaimerViews-___index__roman___2DZ-4","bulleted":"src-components-ExternalInvest-DisclaimerViews-___index__bulleted___X2aHN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalInvest/DisclaimerViews/index.css
// module id = 274
// module chunks = 3